<template>
  <div class="container px-20 mb-24 md:mb-60 relative">
    <div class="mb-38 leading-1.2 z-20 relative w-10/12 md:w-full md:fit-content">
      <h2 class="font-bold text-24 md:text-32 uppercase text-orange fit-content">
        {{ title }}
      </h2>
    </div>

    <div class="absolute z-30 hidden lg:block" style="top: 15px; right: 150px">
      <slot name="link"></slot>
    </div>

    <div class="absolute z-30 top-0 right-0 mr-8 hidden lg:flex">
      <div class="py-12 px-11 rounded-full bg-white bg-orange text-white mr-16 cursor-pointer" @click="$emit('previous')">
        <i class="fal fa-chevron-left fa-fw text-xl"></i>
      </div>

      <div class="py-12 px-11 rounded-full bg-white bg-orange text-white cursor-pointer" @click="$emit('next')">
        <i class="fal fa-chevron-right fa-fw text-xl"></i>
      </div>
    </div>

    <slot name="carousel"></slot>
  </div>
</template>

<script>
export default {
  name: "TitleNavigationLinkPanel",

  props: ['title'],
}
</script>
